import { httpClient } from "ultis/axios";

const loginV2 = (body) => {
  return httpClient.post("/id/user/login-v2", body);
};

const verifyOTP = (body) => {
  return httpClient.post("/id/user/verify-otp", body);
};

const retryOTP = (body) => {
  return httpClient.post("/id/user/retry-otp", body);
};

export const AuthApi = {
  loginV2,
  verifyOTP,
  retryOTP,
};
